module.exports = __webpack_public_path__ + "cae6c220d9f94c174a58bdb7ef335ca7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-zip2.png
// module id = 5TyI
// module chunks = 5